const useStatusMessages = (statusMessages = []) => {
  const getMessage = (group, msgKey, replacements = {}) => {
    const found = statusMessages.find(item => item.group === group && item.msgKey === msgKey);
    if (!found) return null;

    let message = found.msg;
    // Replace placeholders with actual values
    Object.keys(replacements).forEach(key => {
      message = message.replace(`{${key}}`, replacements[key]);
    });

    return message;
  };

  // Optional: Get all messages for a specific group
  const getMessagesByGroup = (group) => {
    return statusMessages.filter(item => item.group === group);
  };

  // Optional: Get all available groups
  const getAvailableGroups = () => {
    return [...new Set(statusMessages.map(item => item.group))];
  };

  return {
    getMessage,
    getMessagesByGroup,
    getAvailableGroups
  };
};

export default useStatusMessages;
